<template>
  <div v-if="isPendingPaymentsButtonVisible">
    <div
      v-for="errorCode in errorCodes"
      :key="errorCode"
      class="m-t-20">
      <bb-banner
        :title="translations.errorTitles[errorCode]"
        type="error"
        visible
        permanent
        class="w-100"
      >
        <div class="f-color-gray">{{ translations.errorDescriptions[errorCode] }}</div>
      </bb-banner>
    </div>
    <bb-button
      color="gray"
      class="m-t-20"
      data-testid="pending-payment-create"
      display="block"
      inverted
      v-bind="button"
      @click="$emit('click')">
      {{ translations.pending.addAs }}
    </bb-button>
  </div>
</template>

<script>
import { useRootStore } from '@/store/root'
import { mapActions, mapState } from 'pinia'
import { pick } from 'lodash'
import dayjs from 'dayjs'
import { AccountRouteName } from '@account/const'
import { usePendingPaymentStore } from '@account/store/pendingPaymentStore'

const VALIDATION_ERRORS = {
  PENDING_PAYMENT_DUPLICATE: 'PENDING_PAYMENT_DUPLICATE',
  GENERIC_ERROR: 'GENERIC_ERROR'
}

const SPECIFIC_ERRORS = [
  VALIDATION_ERRORS.PENDING_PAYMENT_DUPLICATE
]

export default {
  name: 'create-pending-button',
  props: {
    button: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      errorCodes: []
    }
  },
  computed: {
    ...mapState(useRootStore, ['featureFlags']),
    isPendingPaymentsButtonVisible () {
      return this.featureFlags.enablePendingPayments
    },
    translations () {
      return {
        pending: {
          addAs: this.$pgettext('payment_form', 'Add as pending'),
          createdTitle: this.$pgettext('payment_form', 'Pending payment added'),
          createdText: this.$pgettext('payment_form', 'You\'re all set to use this pending payment')
        },
        errorTitles: {
          [VALIDATION_ERRORS.PENDING_PAYMENT_DUPLICATE]: this.$pgettext('pending_payment_create', 'A similar pending payment already exists'),
          [VALIDATION_ERRORS.GENERIC_ERROR]: this.$pgettext('pending_payment_create', 'An error occurred while creating pending payment')
        },
        errorDescriptions: {
          [VALIDATION_ERRORS.PENDING_PAYMENT_DUPLICATE]: this.$pgettext('pending_payment_create', 'Please change pending details and try again.'),
          [VALIDATION_ERRORS.GENERIC_ERROR]: this.$pgettext('pending_payment_create', 'An unexpected error occurred, please try again later.')
        }
      }
    }
  },
  methods: {
    ...mapActions(usePendingPaymentStore, ['createPendingPayment']),
    async create (form, selectedAccountIban) {
      try {
        await this.createPendingPayment({
          ...pick(form, ['description', 'referenceNumber', 'amount', 'recipientIban', 'recipientName']),
          fromIban: selectedAccountIban,
          // Hardcoded to today for first iteration of pending payment
          orderDate: dayjs().format('YYYY-MM-DD')
        })
        this.$router.push({ name: AccountRouteName.PendingPayments, query: { fromIban: selectedAccountIban } })
        this.$notify({
          type: 'success',
          duration: 5000,
          text: this.translations.pending.createdText,
          title: this.translations.pending.createdTitle
        })
      } catch (error) {
        if (error.data?.errors) {
          this.handleErrors(error.data.errors)
        } else if (error?.err_code) {
          this.handleErrors([{ code: error.err_code }])
        }
        throw error
      }
    },
    handleErrors (errors) {
      this.errorCodes = [...new Set(errors.map((error) => SPECIFIC_ERRORS.includes(error.code) ? error.code : VALIDATION_ERRORS.GENERIC_ERROR))]
    }
  }
}
</script>
